import { render, staticRenderFns } from "./DegreeDetailCommon.vue?vue&type=template&id=1baa2329&scoped=true&"
import script from "./DegreeDetailCommon.vue?vue&type=script&lang=js&"
export * from "./DegreeDetailCommon.vue?vue&type=script&lang=js&"
import style0 from "./DegreeDetailCommon.vue?vue&type=style&index=0&id=1baa2329&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1baa2329",
  null
  
)

export default component.exports